import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import styled from 'styled-components';

const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const DesignationSuffixReadOnly = ({k, row, onClickEdit,handleDeleteClick, tableFontSize, SubmitButton,
   page, rowsPerPage}) =>{
    
    return(        
        <>
         <TableRow key={k} name={row.categ}>
            <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}}>
            {(page)*(rowsPerPage)+k+1}
            </TableCell>
            <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
             {row?.name}
            </TableCell>

            <TableCell align="left" sx={{ fontSize: tableFontSize}}>

              <ButtonWrapper>
                <SubmitButton type='button' style={{backgroundColor:"#ed6c02", color:"lightgreen", height:"35px", margin:"0px"}} onClick ={(e)=>onClickEdit(e,k,row)}>Edit</SubmitButton>
                <SubmitButton type='button' style={{backgroundColor:"#D32F2F", color:"lightgreen", height:"35px"}} onClick ={(e)=>handleDeleteClick(e,k, row)}>Delete</SubmitButton>
              </ButtonWrapper>                                    
            </TableCell>
          </TableRow>     
        </>        
    )
}

export default DesignationSuffixReadOnly;